import React from "react";

const PopularSearches = ({ popularSearches = [] }) => (
  <div className="popular__container">
    {popularSearches.map(({ course, topic, lessons }) => (
      <div key={JSON.stringify(lessons)} className="popular__item">
        <span className="popular__course">{course.name}</span>
        <a href={lessons[1].url} className="popular__lesson">
          {lessons[1].name}
        </a>
        <a href={topic.url} className="popular__topic">
          {topic.name}
        </a>
      </div>
    ))}
  </div>
);

export default PopularSearches;



// WEBPACK FOOTER //
// ./app/frontend/components/PopularSearches.js